<script>
import Remove from "./Remove";
import Edit from "./Edit";

export default {
  components: {
    Remove,
    Edit
  },

  props: {
    card: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      removing: false,
      editing: false
    };
  },

  methods: {
    toogleRemoveModal() {
      this.removing = !this.removing;
    },
    toogleUpdateModal() {
      this.editing = !this.editing;
    },

    handleCardUpdating() {
      this.editing = false;
      this.removing = false;

      this.$emit("updateCard");
    }
  },

  computed: {
    brand: function() {
      return this.card.brand;
    },

    icon: function() {
      return {
        VISA: "visa",
        MASTERCARD: "mastercard",
        AMEX: "american-express",
        ELO: "elo",
        DINERS: "diners-club",
        HIPER: "hiper",
        HIPERCARD: "hipercard"
      }[this.brand];
    },

    brandName: function() {
      return this.brand[0] + this.brand.slice(1).toLowerCase();
    }
  }
};
</script>

<template>
  <div class="root-card">
    <div  class="content">
      <div v-if="card.name">
        <p class="card-name">{{ card.name }}</p>
      </div>

      <div class="card-info">
        <img :src="`/static/credit-card/${icon}.svg`" alt="Bandeira cc" />

        <div class="numbers">
          <b>····</b>  {{ card.last4 }}
        </div>
      </div>

      <div class="actions">
        <button
            class="btn btn-small btn-rounded bg-outlined bg-purple-outline"
            @click="toogleUpdateModal"
          >
          <img class="edit" src="/static/icon-edit.svg" />

          <span>editar</span>
        </button>

        <button
            class="btn btn-small btn-rounded bg-outlined bg-purple-outline"
            @click="toogleRemoveModal"
          >
          <img class="remove" src="/static/times-solid.svg" />

          <span>remover</span>
        </button>
      </div>
    </div>

    <Remove
      v-if="removing"
      :id="card.id"
      :icon="icon"
      :brand="brand"
      :brandName="brandName"
      :first6="card.first6"
      :last4="card.last4"
      @exit="toogleRemoveModal"
      @updateCard="handleCardUpdating"
    />

    <Edit
      v-if="editing"
      :id="card.id"
      :icon="icon"
      :brand="brand"
      :brandName="brandName"
      :first6="card.first6"
      :last4="card.last4"
      :name="card.name"
      @exit="toogleUpdateModal"
      @updateCard="handleCardUpdating"
    />
  </div>
</template>

<style scoped>
.content {
  width: 180px;
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: solid 2px #e2e2e2;
  border-radius: 4px;
  cursor: pointer;
  user-select: none;
}

.card-name {
  margin: 0 0 8px;
  font-weight: 400;
  border-bottom: solid 2px #e2e2e2;
}

.card-info {
  display: flex;
  align-items: center;
}

img {
  width: 40px;
  height: 40px;
  margin-right: 4px;
}

.numbers {
  padding-left: 4px;
  border-left: solid 2px #e2e2e2;
  font-weight: 400;
  font-size: 14px;
}

.actions {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.edit,
.remove {
  height: 12px;
  width: 12px;
}

.remove {
  filter: invert(23%) sepia(28%) saturate(2293%) hue-rotate(241deg)
    brightness(97%) contrast(95%);
}

button {
  display: flex;
  align-items: center;
}

.btn {
  margin-top: 8px;
  padding: 6px 12px;
}

.btn > span {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/CreditCards/components/Card.vue